import { IconInfoCircle } from '@tabler/icons-react';
import React, { useId } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import type { OrderItemCustomization } from '~/types/Order';

interface Props {
  customizations: OrderItemCustomization[];
  variant?: 'default' | 'compact';
  placement?: 'top' | 'left' | 'right' | 'bottom';
}

const CartItemCustomizations: React.FC<Props> = ({ customizations, variant = 'default', placement = 'top' }) => {
  const { t } = useTranslation();
  const popoverId = `cart-item-customizations-popover-${useId()}`;

  if (!customizations || customizations.length === 0) {
    return null;
  }

  const triggerClass =
    variant === 'compact'
      ? 'cart-item__customizations-trigger cart-item__customizations-trigger--compact'
      : 'cart-item__customizations-trigger';

  const popover = (
    <Popover id={popoverId} className="cart-item__customizations-popover">
      <Popover.Body>
        <div className="cart-item__customizations-popover-heading">{t('components.cart.customizations_label')}</div>
        <div className="cart-item__customizations-popover-list">
          {customizations.map((c) => (
            <div key={`${c.categoryId}-${c.itemId}`} className="cart-item__customizations-popover-row">
              <div className="cart-item__customizations-popover-label">{c.categoryLabel}</div>
              <div className="cart-item__customizations-popover-value">{c.itemLabel}</div>
            </div>
          ))}
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="cart-item__customizations">
      <OverlayTrigger trigger={['click']} placement={placement} overlay={popover} rootClose>
        <button type="button" className={triggerClass}>
          <span>{t('components.cart.customizations_count', { count: customizations.length })}</span>
          <IconInfoCircle size={14} stroke={2} className="cart-item__customizations-trigger-icon" aria-hidden="true" />
        </button>
      </OverlayTrigger>
    </div>
  );
};

export default CartItemCustomizations;
